'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CartItemField } from './cart-item-field.component';

import { CartItem } from '@/types/cart.types';
import { maskPhone } from '@/utils/formatters/phonenumber';

const STANDALONE_SCHEDULING_NOTICE = 'Confirme o agendamento com o estabelecimento antes de finalizar.';

interface CartItemStandaloneFieldProps {
  item: CartItem;
}

export function CartItemStandaloneField({ item }: CartItemStandaloneFieldProps) {
  const [phone] = item.partner.facility.contacts?.phones ?? [];

  return (
    <CartItemField
      label="Guia avulsa"
      value={(
        <span>
          {STANDALONE_SCHEDULING_NOTICE}
          {phone && (
            <>
              <br />
              <span data-testid={DataTestIdEnum.CART_ITEM_FIELD_STANDALONE_PHONE}>{maskPhone(phone)}</span>
            </>
          )}
        </span>
      )}
      dataTestId={DataTestIdEnum.CART_ITEM_FIELD_STANDALONE}
    />
  );
}
